import { useHistory } from 'react-router'
import { GoLocation } from 'react-icons/go'
import { useIndividualMarketPlace } from '../../../../../pages/individualMarketPlace/individualMarketPlaceContext';

import { Container } from './style';

export function StoreCard({ storeDatas }) {
    const { storesBusinessDatas } = useIndividualMarketPlace()
    const history = useHistory()

  return(
      <Container 
        data-tooltip={`${storeDatas.country + ' - ' + storeDatas.state + ' - ' + storeDatas.city}`}
        colorBgHeader={storesBusinessDatas.colorBgHeader} 
        colorLabel={storesBusinessDatas.colorLabel}
        onClick={() => history.push('/menu/' + storeDatas.nameBusiness)}
      >

        <div className="image">
            <img src={storeDatas.linkProfile} alt={storeDatas.nameBusiness}/>
            {
              storeDatas.isOpenBusiness ?
                <></> :
                <div>
                  <p>Fechado</p>
                </div>
            }
        </div>

        <div className="line"></div>

        <div className="text">
            <pre>{storeDatas.name}</pre>
            <div>
                <GoLocation />
                <p>
                  {storeDatas.country} - {storeDatas.state} - {storeDatas.city} - {storeDatas.neighborhood}
                </p>
            </div>
        </div>

    </Container>
  )
}
